<template>
  <div class="hot_help">
    <van-action-sheet v-model="show" :round="false" class="hh_sheet">
        <div class="hh_title">火热助力</div>
        <div class="hh_con">
          <div class="hh_comp">
            <span>助力企业：</span>
            <span>美利达自行车(中国)有限公司</span>
          </div>
          <div class="hh_money">
            <div class="hh_item">
              <p class="piao">助力1票</p>
              <p class="money">￥1</p>
            </div>
            <div class="hh_item">
              <p class="piao">助力5票</p>
              <p class="money">￥5</p>
            </div>
            <div class="hh_item">
              <p class="piao">助力10票</p>
              <p class="money">￥10</p>
            </div>
            <div class="hh_item">
              <p class="piao">助力88票</p>
              <p class="money">￥88</p>
            </div>
            <div class="hh_item">
              <p class="piao">助力888票</p>
              <p class="money">￥888</p>
            </div>
            <div class="hh_item">
              <p class="piao">助力1688票</p>
              <p class="money">￥1688</p>
            </div>
          </div>
        </div>
    </van-action-sheet>
  </div>
</template>

<script>
export default {
  // 热榜
  name: "hot-help",
  data() {
    return { 
      show: false,           //是否显示火热助力
    };
  },
  components: {},
  computed: {},
  methods: {
    open(){
      this.show=true;
    },
  }
};
</script>

<style scoped lang="scss">
.hot_help{
  .hh_sheet{
    // height: 5rem;
    background: rgba(0,0,0,0.75);
    color: #fff;
    padding-bottom: 0.27rem;
    .hh_title{
      height: 0.85rem;
      line-height: 0.84rem;
      font-size: 0.26rem;
      text-align: center;
      border-bottom: 1px solid #4d4d4d;
    }
    .hh_con{
      padding:0 0.3rem;
      .hh_comp{
        height: 0.87rem;
        line-height: 0.86rem;
        border-bottom: 1px solid #4d4d4d;
        display: flex;
        justify-content: space-between;
        span{
          font-size: 0.26rem;
        }
      }
      .hh_money{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .hh_item{
          width: 2.1rem;
          border-radius: 3px;
          overflow: hidden;
          border:1px solid #fff;
          background: #fff;
          text-align: center;
          color: #fff;
          margin-top: 0.3rem;
          p{
            font-size: 0.26rem;
            &.piao{
              color:#f85b0f;
              height: 0.69rem;
              line-height: 0.69rem;
            }
            &.money{
              line-height: 0.5rem;
              height: 0.5rem;
              background:#f85b0f ;
            }
          }
        }
      }
    }
  }
}
</style>
